import config from "config/config";
import { convertPayloadToQueryString } from "js/utilities";

export async function validatePolicyOwnerNames(payload) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  const response = await fetch(
    `${config.REG_API_BASE_URL}/User/policy/owner?${convertPayloadToQueryString(
      payload
    )}`,
    options
  );

  if (!response.ok) throw response;

  return await response.json();
}
